/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeExpFull,
  MembershipTypeExpFullOptional,
  MembershipTypeExpFullMetaI,
  MembershipTypeExpFullTrackedI,
} from "./membership-type-exp-full";
import {
  MembershipTypeExpFullTracked,
  MembershipTypeExpFullMeta,
} from "./membership-type-exp-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeRef,
  MembershipTypeRefOptional,
  MembershipTypeRefMetaI,
  MembershipTypeRefTrackedI,
} from "./membership-type-ref";
import {
  MembershipTypeRefTracked,
  MembershipTypeRefMeta,
} from "./membership-type-ref";

/**
 *
 * @export
 * @interface MembershipTypeExpDTO
 */
export interface MembershipTypeExpDTOOptional extends MembershipTypeExpFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  season?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  expirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdBy?: string;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipTypeExpDTO
   */
  membershipTypeId?: MembershipTypeRefOptional;
}

export interface MembershipTypeExpDTO
  extends MembershipTypeExpDTOOptional, MembershipTypeExpFull {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  season?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  expirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdBy?: string;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipTypeExpDTO
   */
  membershipTypeId?: MembershipTypeRef;
}

export interface MembershipTypeExpDTOTrackedI extends MembershipTypeExpFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeExpDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpDTO
   */
  season?: number;
  seasonIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  startDate?: Date;
  startDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  expirationDate?: Date;
  expirationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipTypeExpDTO
   */
  membershipTypeId?: MembershipTypeRefTrackedI;
  membershipTypeIdIsSet: boolean;
}

transformDatesMap.set(
  "MembershipTypeExpDTO",
  function (model: MembershipTypeExpDTO) {
    if (typeof model.startDate == "string")
      model.startDate = new Date(model.startDate);
    if (typeof model.expirationDate == "string")
      model.expirationDate = new Date(model.expirationDate);
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
    const transformDatesmembershipTypeId =
      transformDatesMap.get("MembershipTypeRef");
    if (transformDatesmembershipTypeId && model.membershipTypeId) {
      transformDatesmembershipTypeId(model.membershipTypeId);
    }
  },
);

export type MembershipTypeExpDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  season: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  expirationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  membershipTypeId: PropertyMeta<MembershipTypeRefMetaI>;
}>;

export var MembershipTypeExpDTOMeta: MembershipTypeExpDTOMetaI =
  {} as MembershipTypeExpDTOMetaI;
MembershipTypeExpDTOMeta = typeMeta("MembershipTypeExpDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  season: propertyMeta("season", false, false, false, MetaTypesBase.number),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
  expirationDate: propertyMeta(
    "expirationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  membershipTypeId: propertyMeta(
    "membershipTypeId",
    false,
    false,
    false,
    MembershipTypeRefMeta,
  ),
});

const metaI = MembershipTypeExpDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([MembershipTypeExpFullMeta]);
  metaI.isDeleted.inheritedFrom = MembershipTypeExpFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = MembershipTypeExpFullMeta.isNew;
  metaI.assignId.inheritedFrom = MembershipTypeExpFullMeta.assignId;
  metaI.season.inheritedFrom = MembershipTypeExpFullMeta.season;
  metaI.startDate.inheritedFrom = MembershipTypeExpFullMeta.startDate;
  metaI.expirationDate.inheritedFrom = MembershipTypeExpFullMeta.expirationDate;
  metaI.updatedOn.inheritedFrom = MembershipTypeExpFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = MembershipTypeExpFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = MembershipTypeExpFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = MembershipTypeExpFullMeta.createdBy;
  metaI.membershipTypeId.inheritedFrom =
    MembershipTypeExpFullMeta.membershipTypeId;
});

export class MembershipTypeExpDTOTracked
  extends MembershipTypeExpFullTracked
  implements MembershipTypeExpDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  season__I?: number = undefined;
  seasonIsSet: boolean = false;
  set season(v: undefined | number) {
    if (v !== undefined) {
      this.season__I = v;
      this.seasonIsSet = true;
    } else {
      this.season__I = v || undefined;
      this.seasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get season() {
    return this.season__I;
  }
  startDate__I?: Date = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | Date) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  expirationDate__I?: Date = undefined;
  expirationDateIsSet: boolean = false;
  set expirationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.expirationDate__I = v;
      this.expirationDateIsSet = true;
    } else {
      this.expirationDate__I = v || undefined;
      this.expirationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get expirationDate() {
    return this.expirationDate__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  membershipTypeId__I?: MembershipTypeRefTracked = undefined;
  membershipTypeIdIsSet: boolean = false;
  set membershipTypeId(v: undefined | MembershipTypeRefTracked) {
    if (v !== undefined) {
      this.membershipTypeId__I = v;
      this.membershipTypeIdIsSet = true;
    } else {
      this.membershipTypeId__I = v || undefined;
      this.membershipTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get membershipTypeId() {
    return this.membershipTypeId__I;
  }
  constructor(config?: MembershipTypeExpDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.membershipTypeId?.setIds();
  }
  assignFrom(
    config: MembershipTypeExpDTOOptional,
    options?: AssignOptions,
  ): MembershipTypeExpDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.season && this.seasonApplyFilter(optionsRequired.filter)) {
      this.season = config.season;
      if (optionsRequired.unassign) this.seasonIsSet = false;
      else this.seasonIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (
      config.expirationDate &&
      this.expirationDateApplyFilter(optionsRequired.filter)
    ) {
      this.expirationDate = config.expirationDate;
      if (optionsRequired.unassign) this.expirationDateIsSet = false;
      else this.expirationDateIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.membershipTypeId &&
      this.membershipTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.membershipTypeId = new MembershipTypeRefTracked(
        config.membershipTypeId,
        options,
      );
      if (optionsRequired.unassign) this.membershipTypeIdIsSet = false;
      else this.membershipTypeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): MembershipTypeExpDTOTrackedI {
    const cloned = {} as MembershipTypeExpDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.seasonIsSetDeep() &&
      this.seasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.seasonIsSet = true;
      cloned.season = this.season;
    } else {
      //cloned.seasonIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.expirationDateIsSetDeep() &&
      this.expirationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expirationDateIsSet = true;
      cloned.expirationDate = this.expirationDate;
    } else {
      //cloned.expirationDateIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.membershipTypeIdIsSetDeep() &&
      this.membershipTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipTypeIdIsSet = true;
      cloned.membershipTypeId = this.membershipTypeId?.removeUnset(filter);
    } else {
      //cloned.membershipTypeIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): MembershipTypeExpDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.seasonApplyFilter(filter)) this.seasonIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.expirationDateApplyFilter(filter))
      this.expirationDateIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.membershipTypeIdApplyFilter(filter))
      this.membershipTypeIdIsSet = false;
    this.membershipTypeId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.isDeleted,
      MembershipTypeExpDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.isNew,
      MembershipTypeExpDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.assignId,
      MembershipTypeExpDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  seasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.season,
      MembershipTypeExpDTOMeta,
      this.season,
      this,
    );
  }
  seasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.seasonIsSet && this.seasonApplyFilter(filter)) return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.startDate,
      MembershipTypeExpDTOMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  expirationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.expirationDate,
      MembershipTypeExpDTOMeta,
      this.expirationDate,
      this,
    );
  }
  expirationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expirationDateIsSet && this.expirationDateApplyFilter(filter))
      return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.updatedOn,
      MembershipTypeExpDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.updatedBy,
      MembershipTypeExpDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.createdOn,
      MembershipTypeExpDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.createdBy,
      MembershipTypeExpDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  membershipTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpDTOMeta.membershipTypeId,
      MembershipTypeExpDTOMeta,
      this.membershipTypeId,
      this,
    );
  }
  membershipTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipTypeIdIsSet && this.membershipTypeIdApplyFilter(filter))
      return true;
    return this.membershipTypeId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.seasonIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.expirationDateIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.membershipTypeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
